module.exports = __webpack_public_path__ + "images/category_lp/camera/new/store_images/1_3ca66912c4f3c6b8e6b92ebfa75abbc6.png";